import { Timestamp } from '@angular/fire/firestore';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ILeadAssessment } from '@leads/shared/models/firebase/scheduled-assessment.model';
import { ICurrency } from '@shared/models/numbers';

export type JobCard = {
	startTime: Timestamp | null;
	endTime: Timestamp | null;
	materials: Array<IJobCardMaterial>;
	notes: string | null;
};

export interface ISignedJobCard extends Pick<ILeadAssessment, 'assessmentDetails' | 'jobCard'> {}

export interface IJobCardMaterial {
	quantity: number;
	description: string;
	amount: ICurrency;
}

export interface IJobCardMaterialForm {
	quantity: FormControl<number | null>;
	description: FormControl<string | null>;
	amount: FormControl<number | null>;
}

export interface IJobCardForm {
	startTime: FormControl<string | null>;
	endTime: FormControl<string | null>;
	jobNotes: FormControl<string | null>;
	materials: FormArray<FormGroup<IJobCardMaterialForm>>;
	attachments: FormControl<File[] | null>;
}

export enum JobCardViewSteps {
	MATERIALS = 'materials',
	ATTACHMENTS = 'attachments',
}
